export default {
  init() {
    // JavaScript to be fired on all pages
    console.log("common");

    const burgerMenu = document.querySelector("#headerInput");

    burgerMenu.addEventListener("click", () => {
      document.body.classList.toggle("disable-scroll");
    });

    const subMenuItems = document.querySelectorAll(".sub-menu li a");

    subMenuItems.forEach((subMenuItem) => {
      subMenuItem.addEventListener("click", () => {
        document.body.classList.remove("disable-scroll");
        document.getElementById("headerInput").checked = false;
      });
    });

    const menuItems = document.querySelectorAll(
      ".container-mobile .my-header-menu > .menu-item.menu-item-has-children > a"
    );
    // console.log(menuItems)
    menuItems.forEach((menuItem) => {
      menuItem.addEventListener("click", () => {
        const menuSubItem = menuItem.parentNode.querySelector(".sub-menu");
        menuSubItem.classList.toggle("opened");
      });

      // console.log(menuSubItem)
    });

    /* 
      init all toggle show/hide password */
    function initToggleShowHidePassword() {
      const $passwords = document.querySelectorAll(".input-text-container");
      if ($passwords.length === 0) return;
      $passwords.forEach(($container) => {
        const $input = $container.querySelector("input");
        const $icon = $container.querySelector(".input-text-icon");
        if (!$input | !$icon) return;
        $icon.addEventListener("click", () => {
          const current = $input.type;
          if (current === "password") {
            $input.type = "text";
          } else if (current === "text") {
            $input.type = "password";
          }
        });
      });
    }
    initToggleShowHidePassword();
    
    function initToggleMenus() {
      function closeAllMenus($menus) {
        $menus.forEach(($menu) => {
          $menu.classList.remove("open");
        });
      }
      const $menus = document.querySelectorAll("[data-toggle-menu]");
      let lastMenuOpen = null;
      if ($menus.length === 0) return;
      $menus.forEach((menu) => {
        const menuId = menu.dataset.toggleMenu;
        const selector = `[data-toggle-btn="${menuId}"]`;
        const $toggles = document.querySelectorAll(selector);
        if ($toggles.length === 0) return;
        $toggles.forEach(($toggle) => {
          $toggle.addEventListener("click", () => {
            if(lastMenuOpen !== menuId) closeAllMenus($menus);
            lastMenuOpen = menuId;
            menu.classList.toggle("open");
          });
        });
      });
    }
    initToggleMenus()
   

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
